module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "isDashboard": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.show) ? _c('v-table', {
    attrs: {
      "productScanStatisticsList": _vm.productScanStatisticsList
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [(_vm.show) ? _c('v-codeRanking', {
    attrs: {
      "provinceStatisticsList": _vm.provinceStatisticsList
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.cityStatisticsList.length > 0) ? _c('v-center', {
    attrs: {
      "totalRelationCount": _vm.totalRelationCount,
      "cityStatisticsList": _vm.cityStatisticsList
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.show) ? _c('v-harvestingPlan', {
    attrs: {
      "productRelationStatisticsList": _vm.productRelationStatisticsList
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [(_vm.show) ? _c('v-product', {
    attrs: {
      "productRelationStatisticsList": _vm.productScanStatisticsList
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    on: {
      "click": _vm.next
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-758adc30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/trace/index.vue
// module id = 2044
// module chunks = 2